import {
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  RESET_CATEGORY_STATE,
} from '../../../types/category';

const initialState = {
  loading: false,
  category: null,
  error: null,
  success: false,
};

const createCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case CREATE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        category: action.payload,
        success: true,
      };

    case CREATE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case RESET_CATEGORY_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default createCategoryReducer;
